import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EventManagerService } from '@wms/app/event-manager';
import { split } from 'lodash-es';

@Component({
  selector: 'wms-spacing-control',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './spacing-control.component.html',
  styleUrl: './spacing-control.component.less'
})
export class SpacingControlComponent {
  @Input() property: string;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  private eventManager: EventManagerService;
  isIndividual: boolean = false;
  readonly UNSET = 'unset';
  dataVal: any;
  spacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };

  @Input() set dataValue(val: any) {
    this.dataVal = val;
    this.watch(this.dataVal)
  }

  constructor(){
    this.eventManager = inject(EventManagerService);
  }

  ngOnInit() {
    const spacing = split(this.dataVal, ' ')
    if (spacing.length <= 2) {
      this.isIndividual = false
    } else if (spacing.length > 2)
      this.isIndividual =  (spacing[0] === spacing[2] && spacing[1] === spacing[3]) ? false : true;
  }

  splitIntoParts(model: any) {
    let parts: any = split(model, ' ');

    if (parts.length === 1) {
      parts.push(parts[0], parts[0], parts[0]);
    }
    else if (parts.length === 2) {
      parts.push(parts[0], parts[1]);
    }

    this.spacing.top = this.toValid(parts[0]) || 0;
    this.spacing.right = this.toValid(parts[1]) || 0;
    this.spacing.bottom = this.toValid(parts[2]) || 0;
    this.spacing.left = this.toValid(parts[3]) || 0;
  }

  watch(e: string) {
    this.splitIntoParts(e);
  }

  get verticalDisplay(): any {
      const top = this.spacing.top ?? 0;
      const bottom = this.spacing.bottom ?? 0;
    return top === bottom ? `${top}` : `${top},${bottom}`;

  }

  get horizontalDisplay(): string {
      const left = this.spacing.left ?? 0;
      const right = this.spacing.right ?? 0;
      return left === right ? `${left}` : `${left},${right}`;
  }

  toValid(val: any) {
    if (!val) {
      return;
    }
    if (val === this.UNSET) {
      return;
    }
    const _val = val.replace('px', '');
    if (!_val) {
      return;
    }
    return _val;
  }

  updateAxisValues(event: any, axis: 'vertical' | 'horizontal') {
    const inputEl = event?.target as HTMLInputElement;
    const value = (inputEl?.value ?? '').trim();

    let first = 0, second = 0;

    if (value.includes(',')) {
      const [firstStr, secondStr] = value.split(',').map((v: string) => v.trim());
      first = firstStr === '' ? 0 : +firstStr;
      second = secondStr === '' ? 0 : +secondStr;
    } else {
      const num = value === '' ? 0 : +value;
      first = num;
      second = num;
    }

    if (axis === 'vertical') {
      this.spacing.top = isNaN(first) ? 0 : first;
      this.spacing.bottom = isNaN(second) ? 0 : second;
      inputEl.value = this.verticalDisplay; 
    } else {
      this.spacing.left = isNaN(first) ? 0 : first;
      this.spacing.right = isNaN(second) ? 0 : second;
      inputEl.value = this.horizontalDisplay; 
    }
    this.triggerOnChange();
  }

  toggleLink() {
    this.isIndividual = !this.isIndividual;
  }

  onSpacingingChange(key: string) {
    const num = (this.spacing as any)[key];
    (this.spacing as any)[key] = num === '' || num === null ? 0 : +num;
    this.triggerOnChange();
  }

  triggerOnChange() {
    let updatedModel = this.getUpdatedModelOnChange();
    this.onChange.emit(updatedModel);
  }

  getUpdatedModelOnChange() {
    let unit = 'px',
      top: any = this.spacing.top,
      right: any = this.spacing.right,
      bottom: any = this.spacing.bottom,
      left: any = this.spacing.left,
      expr;

    top = top ? top + unit : this.UNSET;
    right = right ? right + unit : this.UNSET;
    bottom = bottom ? bottom + unit : this.UNSET;
    left = left ? left + unit : this.UNSET;

    if (top === bottom && left === right) {
      if (top === left) {
        expr = top;
      } else {
        expr = top + ' ' + left;
      }
    } else {
      expr = top + ' ' + right + ' ' + bottom + ' ' + left;
    }

    if (expr === this.UNSET) {
      return;
    }

    return expr;
  }

   setActiveProperty(property: string) {
    this.eventManager.emitsetActiveprop(property);
  }

}
